const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Client",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "Mobile Number",
    dataIndex: "mobile_no",
    render: defaultRender,
    width: 120,
  },
];

export default columns;
